// Generated by genversion.
export const version = '23.17.4';
